import { BiCreditCard, BiGlobe, BiHomeAlt } from "react-icons/bi";

const AboutUs = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 pt-16 pb-20">
      <div className="flex flex-wrap gap-24">
        <div className="relative flex-1 basis-[18rem] border">
          <img
            src="/images/home/about/about.jpg"
            alt=""
            className="object-cover w-full h-full rounded-lg"
          />
          <img
             src="/images/home/about/about1.jpg"
            alt=""
            className="absolute object-cover w-48 h-60 border-4 border-white rounded-lg sm:w-72 sm:h-80 dark:border-dark -bottom-20 -right-2 md:-right-20"
          />
        </div>
        <div className="relative flex-1 basis-[22rem]">
        <h1 className="sub-heading">About Us</h1>
        <h1 className="heading">Transforming Your Home Environment</h1>
          <p className="mt-3">
             Pool Home Care is a trusted name in swimming pool construction and water park solutions, with over 10+ years of experience. We specialize in delivering innovative designs for pools, spas, steam rooms, and Jacuzzis, catering to both residential and commercial clients.
          </p>

          <div className="mt-4">
            <div className="flex-align-center gap-x-2">
              <div className="icon-box text-primary !bg-primary/20">
                <BiHomeAlt />
              </div>
              <div>

              <h1 className="font-semibold">Our Vision</h1>
              <p>
                To be the leading provider of water-based leisure and wellness solutions, offering top-quality services and innovative designs.
              </p>
              </div>
            </div>

            <div className="mt-3 flex-align-center gap-x-2">
              <div className="icon-box text-primary !bg-primary/20">
                <BiGlobe />
              </div>
              <div>
              <h1 className="font-semibold">Our Mission</h1>
              <p>
                To deliver high-quality and sustainable water park equipment, ensuring client satisfaction through expertise and innovation.
              </p>
              </div>
            </div>

            <div className="mt-3 flex-align-center gap-x-2">
              <div className="icon-box text-primary !bg-primary/20">
                <BiCreditCard />
              </div>
              <div>
             <h1 className="font-semibold">Our Goal</h1>
              <p>
                To enhance lifestyle experiences by creating world-class water leisure environments with premium-grade products and services.
              </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
